<template>
  <ion-grid class="ion-no-padding" style="cursor: pointer">
    <img
      :src="event ? event.flyer : 'https://via.placeholder.com/1080x1350'"
      :alt="'Flyer - ' + event?.name"
      class="os-flyer mb-md os-rounded-border"
      @click="
        $router.push(`/event/${event?.customUrl ? event.customUrl : event?.id}`)
      "
    />
    <div class="text-body">
      <span class="os-bold">{{
        event ? event.name : "Titulo del evento se vera aquí"
      }}</span>
      <br />
      {{
        event
          ? dateFormatting(event.dates[0].startDate, "DD [de] MMMM YYYY")
          : "(día) del (mes) (año)"
      }}
    </div>
  </ion-grid>
</template>

<script setup lang="ts">
import { IonGrid } from "@ionic/vue";

import { defineProps } from "vue";

import Event from "@/types/Event";

import compGeneralAppUtils from "@/composables/generalAppUtils";
const { dateFormatting } = compGeneralAppUtils();

defineProps<{
  event?: Event;
}>();
</script>
